import React from "react";
import SEO from "../components/SEO";

const Embroider = () => {
  return (
    <>
      <SEO
        title='Embroidery'
        description='Shirts Patches'
        keywords='Shirts Patches'
      />
      <div className="bg-gradient-to-b from-[#437d6a]/10 to-white min-h-screen py-20">
        <div className="container mx-auto px-4 max-w-6xl">

          {/* Header */}
          <div className="text-center mb-24">
            <h1 className="text-4xl md:text-5xl font-extrabold text-[#437d6a] drop-shadow-md">
              Personalised Hat Patches - Media & Publication Division
            </h1>
            <p className="mt-4 text-gray-700 text-lg max-w-3xl mx-auto">
              Powered by <span className="font-semibold">Personalised Hat Patches</span> – providing educational resources, tutorials, and authoritative content for patch enthusiasts and professionals in the U.S.
            </p>
          </div>

          {/* About Section */}
          <section className="bg-white rounded-3xl shadow-2xl p-8 md:p-14 space-y-12 relative overflow-hidden">
            {/* Decorative Background Elements */}
            <div className="absolute -top-20 -right-20 w-72 h-72 bg-[#437d6a]/10 rounded-full pointer-events-none"></div>
            <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-[#437d6a]/5 rounded-full pointer-events-none"></div>

            <h2 className="text-3xl font-bold text-[#437d6a] mb-4 relative z-10">
              Headquartered in the USA – Targeting the U.S Audience
            </h2>
            <p className="text-gray-700 leading-relaxed text-lg relative z-10">
              Personalised Hat Patches is a U.S.-based manufacturer of high-quality custom hat patches. While our core business focuses on producing embroidered, woven, and specialty patches, our media and publication division provides educational resources, tutorials, and authoritative content to help embroidery professionals, hobbyists, and businesses learn the art and science of creating patches.
            </p>

            {/* What We Do */}
            <div className="space-y-8 relative z-10">
              <h2 className="text-2xl font-bold text-[#437d6a] mb-6">What We Do</h2>
              <ul className="grid md:grid-cols-3 gap-6">
                <li className="flex flex-col items-start p-6 bg-gradient-to-b from-[#437d6a]/10 to-white rounded-2xl shadow-lg hover:scale-105 hover:shadow-2xl transition transform duration-300">
                  <div className="w-14 h-14 mb-4 flex items-center justify-center bg-[#437d6a]/20 text-[#437d6a] rounded-full text-3xl">
                    📘
                  </div>
                  <p className="text-gray-700">
                    <span className="font-semibold text-[#437d6a]">Educational Content:</span> Articles, tutorials, and industry information about patch design, embroidery, digitizing, and machine operation.
                  </p>
                </li>
                <li className="flex flex-col items-start p-6 bg-gradient-to-b from-[#437d6a]/10 to-white rounded-2xl shadow-lg hover:scale-105 hover:shadow-2xl transition transform duration-300">
                  <div className="w-14 h-14 mb-4 flex items-center justify-center bg-[#437d6a]/20 text-[#437d6a] rounded-full text-3xl">
                    🛠️
                  </div>
                  <p className="text-gray-700">
                    <span className="font-semibold text-[#437d6a]">Tutorials & Workshops:</span> Learning materials and step-by-step instructions developed and tested by our embroidery professionals.
                  </p>
                </li>
                <li className="flex flex-col items-start p-6 bg-gradient-to-b from-[#437d6a]/10 to-white rounded-2xl shadow-lg hover:scale-105 hover:shadow-2xl transition transform duration-300">
                  <div className="w-14 h-14 mb-4 flex items-center justify-center bg-[#437d6a]/20 text-[#437d6a] rounded-full text-3xl">
                    💡
                  </div>
                  <p className="text-gray-700">
                    <span className="font-semibold text-[#437d6a]">Thought Leadership:</span> Showcasing innovations, best practices, and trends in embroidery and custom patch production across the United States.
                  </p>
                </li>
              </ul>
            </div>

            {/* Why Personalised Hat Patches */}
            <div className="space-y-8 relative z-10">
              <h2 className="text-2xl font-bold text-[#437d6a] mb-6">Why Personalised Hat Patches</h2>
              <ul className="grid md:grid-cols-3 gap-6">
                <li className="flex flex-col items-start p-6 bg-gradient-to-b from-[#437d6a]/10 to-white rounded-2xl shadow-lg hover:scale-105 hover:shadow-2xl transition transform duration-300">
                  <div className="w-14 h-14 mb-4 flex items-center justify-center bg-[#437d6a]/20 text-[#437d6a] rounded-full text-3xl">
                    🏆
                  </div>
                  <p className="text-gray-700">
                    <span className="font-semibold text-[#437d6a]">Experience in the Industry:</span> Backed by decades of producing high-quality custom patches for schools, businesses, military units, and creative communities across the U.S.
                  </p>
                </li>
                <li className="flex flex-col items-start p-6 bg-gradient-to-b from-[#437d6a]/10 to-white rounded-2xl shadow-lg hover:scale-105 hover:shadow-2xl transition transform duration-300">
                  <div className="w-14 h-14 mb-4 flex items-center justify-center bg-[#437d6a]/20 text-[#437d6a] rounded-full text-3xl">
                    ✍️
                  </div>
                  <p className="text-gray-700">
                    <span className="font-semibold text-[#437d6a]">Professionally-written and Edited Content:</span> All tutorials, articles, and resources are written or edited by embroidery experts with hands-on experience.
                  </p>
                </li>
                <li className="flex flex-col items-start p-6 bg-gradient-to-b from-[#437d6a]/10 to-white rounded-2xl shadow-lg hover:scale-105 hover:shadow-2xl transition transform duration-300">
                  <div className="w-14 h-14 mb-4 flex items-center justify-center bg-[#437d6a]/20 text-[#437d6a] rounded-full text-3xl">
                    🔍
                  </div>
                  <p className="text-gray-700">
                    <span className="font-semibold text-[#437d6a]">Trusted Expertise:</span> Our media division leverages the extensive experience of Personalised Hat Patches to deliver accurate, valuable, and practical embroidery information.
                  </p>
                </li>
              </ul>
            </div>

            {/* CTA Section */}
            <div className="mt-12 text-center relative z-10">
              <h3 className="text-2xl md:text-3xl font-bold text-[#437d6a] mb-4">
                Explore Our Tutorials & Resources
              </h3>
              <p className="text-gray-700 mb-6">
                Learn, create, and master custom patch design with our step-by-step guides and resources.
              </p>
              {/* <a
              href="/tutorials"
              className="inline-block bg-[#437d6a] text-white px-10 py-4 rounded-xl font-semibold hover:bg-[#2f5c48] transition"
            >
              View Tutorials
            </a> */}
            </div>

            {/* Footer Note */}
            <p className="text-sm text-gray-500 text-center pt-6 border-t border-gray-200 relative z-10">
              Last updated: 01/12/2026
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Embroider;
